import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { createContext, useContext } from 'react';

const AmplitudeContext = createContext(amplitude);

export function useAmplitude() {
  const context = useContext(AmplitudeContext);

  if (!context) throw new Error('useAmplitude must be used within a AmplitudeProvider');

  return context;
}

export function AmplitudeProvider({ children }) {
  // Create and Install Session Replay Plugin
  const amplitudeSampleRate = process.env.REACT_APP_AMPLITUDE_SAMPLE_RATE;
  // If the sample rate is not set, use remote configuration or default is 0
  const sampleRate = amplitudeSampleRate && amplitudeSampleRate !== '' ? Number(amplitudeSampleRate) : undefined;
  const sessionReplayTracking = sessionReplayPlugin({
    sampleRate,
  });
  amplitude.add(sessionReplayTracking);
  const urlParams = new URLSearchParams(window.location.search);
  const deviceId = urlParams.get('amp_device_id') ?? null;
  
  amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY, {
    autocapture: {
      attribution: true,
      pageViews: true,
      sessions: false,
      formInteractions: false,
      fileDownloads: false,
      elementInteractions: false,
    },
    deviceId
  });

  return <AmplitudeContext.Provider value={amplitude}>{children}</AmplitudeContext.Provider>;
}
